"use strict";

import {Vue} from "ui.vue";
import {Vuex} from "ui.vue.vuex";

Vue.component('bx-builder-select-cost', {
	date: () => {
		return{}
	},
	computed:{
		...Vuex.mapState({
			cost: state => state.result.cost
		})
	},
	methods:{
		changeCost:function (cost) {
			this.$store.dispatch('changeCost', cost);
		}
	},
	template:
	`
	<div class="builder_select-cost">
		<h3 class="builder_sub-title">
			Ваш бюджет:
		</h3>
		<div class="cost_block-wrap">
			<button @click="changeCost(2000)" :class="{'active': cost == 2000}" class="builder_select-btn">2000 Р</button>
			<button @click="changeCost(3000)" :class="{'active': cost == 3000}" class="builder_select-btn">3000 Р</button>
			<button @click="changeCost(4000)" :class="{'active': cost == 4000}" class="builder_select-btn">4000 Р</button>
			<button @click="changeCost(5000)" :class="{'active': cost == 5000}" class="builder_select-btn">5000 Р</button>
			<button @click="changeCost(10000)" :class="{'active': cost == 10000}" class="builder_select-btn">10000 Р</button>
		</div>
	</div>
	`
})
